<template>
    <div class="layout-ccc-line dsp-flex">
        <div class="layout-ccc-label layout-ccc-label-medicine" @click="clickItem"><span class="label-medicine">{{medicineData.text.slice(0, 8)}}</span><i class="iconfont icon-down"></i></div>
        <div class="layout-ccc-note">
            <input class="layout-ccc-input" @focus="focusMedicine" @blur="blurMedicine" v-model="inputText" type="text" placeholder="请输入">
            <div class="layout-ccc-fake-input" @click="clickFakeInput"></div>
            <span class="layout-ccc-save" v-if="(!medicineData.content && inputText != '') || (medicineData.content && inputText != medicineData.content)" @click="clickSave">保存</span>
        </div>
        <div class="layout-ccc-side">
            <i v-if="medicineData.withSub" @click="clickSub" class="iconfont icon-sub layout-ccc-icon"></i>
            <i v-if="medicineData.withPlus" @click="clickPlus" class="iconfont icon-plus layout-ccc-icon"></i>
        </div>
    </div>
</template>

<script>
import { UA } from '../../modules/utils';
import { COMMENT_DOM } from '../../modules/dom';
export default {
    name: 'CommentMedicineItem',
    props: ['medicineData', 'itemFunc', 'saveFunc', 'subFunc', 'plusFunc'],
    data() {
        return {
            inputText: '',
            showFakeFocus: false,
            curFakeInputNode: null,
        }
    },
    mounted: function() {
        this.inputText = this.medicineData.content ? this.medicineData.content : '';
        this.showFakeFocus = UA.isIphone();
    },
    methods: {
        clickItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc('medicine', this.medicineData);
            }
        },
        clickSave() {
            if(this.inputText == '') {
                this.$toast('请输入药的内容')
                return;
            }
            if(this.saveFunc && typeof(this.saveFunc) == 'function') {
                this.saveFunc(this.inputText, this.medicineData)
            }
        },
        clickSub() {
            if(this.subFunc && typeof(this.subFunc) == 'function') {
                this.subFunc(this.medicineData);
            }
        },
        clickPlus() {
            if(this.plusFunc && typeof(this.plusFunc) == 'function') {
                this.plusFunc(this.medicineData);
            }
        },
        clickFakeInput(event) {
            var me = this,
                curNode = event.target,
                inputNode = curNode.previousElementSibling;
            
            this.curFakeInputNode = curNode;
            this.curFakeInputNode.style = 'display: none';
            inputNode.focus();
            
            // 光标定位到文本末尾
            var leng = this.inputText.length;
            inputNode.setSelectionRange(leng, leng);

            if(UA.isIphone()) {
                var curNode2 = this.$el;
                setTimeout(() => {
                    COMMENT_DOM.updateMedicineInputScrollTop(curNode2, true);
                }, 300);
            }
        },
        focusMedicine() {
            var showLines = this.$store.state.minifatefortune.showLines;
            if(showLines == 2){
                this.$store.state.minifatefortune.showLines = 1;
                COMMENT_DOM.updateCommentFormStyle();
            }

            var curNode = this.$el;
            if(curNode == null) { return; }

            if(UA.isIphone()) {
                this.$store.state.comment.showBottomBar = false;
                // 设置顶部菜单的样式
                var topbarDiv = document.getElementsByClassName('comment-fate-topbar')[0];
                topbarDiv.style = 'position: absolute; left: 0; top: 0';

            }else if(UA.isAndroid()) {
                this.$store.state.comment.showBottomBar = false;

                // 安卓滚动到当前输入框的位置:弹出软键盘之后再滚动
                var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
                var me = this;
                window.onresize = function() {
                    setTimeout(() => {
                        var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                        if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                            me.$store.state.comment.showBottomBar = false;
                        }else{
                            me.$store.state.comment.showBottomBar = true;
                        }
                    }, 100);
                    setTimeout(() => {
                        COMMENT_DOM.updateMedicineInputScrollTop(curNode, false);
                    }, 300);
                }
            }
        },
        blurMedicine() {

            var curNode = this.$el;

            if(UA.isIphone()) {
                this.$store.state.comment.showBottomBar = true;
                // 设置顶部菜单的样式
                var topbarDiv = document.getElementsByClassName('comment-fate-topbar')[0];
                topbarDiv.style = '';

                if(this.curFakeInputNode != null) {
                    this.curFakeInputNode.style = '';
                }
                COMMENT_DOM.updateCommentFormStyle();
                setTimeout(() => {
                    COMMENT_DOM.updateMedicineInputScrollTop(curNode, false);
                }, 100);
            }
            if(UA.isAndroid()) {
                this.$store.state.comment.showBottomBar = true;
            }
            // this.clickSave();
        }
    }
}
</script>